import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent {

  constructor() { }

}
